// India-specific reference data used by the customer form.
export const INDIAN_STATES = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
  // Union Territories
  "Andaman and Nicobar Islands",
  "Chandigarh",
  "Dadra and Nagar Haveli and Daman and Diu",
  "Delhi",
  "Jammu and Kashmir",
  "Ladakh",
  "Lakshadweep",
  "Puducherry",
];

export const RELATION_TYPES = [
  { value: "", label: "—" },
  { value: "s_o", label: "S/o (Son of)" },
  { value: "w_o", label: "W/o (Wife of)" },
  { value: "d_o", label: "D/o (Daughter of)" },
  { value: "represented_by", label: "Represented by" },
];

export const GENDER_OPTIONS = [
  { value: "", label: "—" },
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
  { value: "other", label: "Other" },
];

export function relationLabel(value) {
  return RELATION_TYPES.find((r) => r.value === value)?.label || "";
}

export const PIN_RE = /^[1-9]\d{5}$/;

export function customerPin(c) {
  for (const k of ["pin_code", "pincode"]) {
    const v = String(c?.[k] ?? "").trim().replace(/\.0$/, "");
    if (PIN_RE.test(v)) return v;
  }
  return "";
}
